exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".changeLogObjectChange[data-v-03e532e8]{flex:1;display:flex;flex-direction:column;align-items:center;background-color:#333;border-radius:10px;padding:10px;margin:10px}.changeLogObjectChange .arrow[data-v-03e532e8]{color:#777;font-size:12px;padding:3px 0}.changeLogObjectChange .attribute[data-v-03e532e8]{text-align:center}.changeLogObjectChange .imgContainer[data-v-03e532e8]{width:128px;height:128px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-03e532e8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ChangeLogObjectChange.vue
// module id = 162
// module chunks = 0